export default "__VITE_ASSET__kx6RBnFq__"